import { useLocation } from 'js/lib/useRouter';

const usePaginationData = (total: number, itemsPerPage: number) => {
  const {
    query: { page },
  } = useLocation();
  const currentPage = page ? parseInt(page, 10) : 1;
  const pageCount = Math.ceil(total / itemsPerPage);
  return { currentPage, pageCount };
};

export default usePaginationData;
